import React, { useEffect } from "react";
import { Link } from "react-router-dom";

import { removePrerender } from '../asyncComponent';

import Layout from "../layout/Layout";

import "./Home.css";

const Home = () => {

  useEffect(() => {
    removePrerender();
  }, []);

  return (
    <Layout onHome>
        
      <div className="HomePage">
        
        <p>
          I am software developer in Sydney.<br/>
          Recently, in my spare time I have worked on computer algorithms for
          calendar-date and timestamp conversion, for both Earth and Mars. Some&nbsp;of&nbsp;these&nbsp;algorithms
          are the fastest in their class, and have been adopted by LLVM and Webkit.
        </p>

        <p>
          I also have a deep interest in mathematics and cartography. I have developed a range
          of novel map projections that will be released in the coming months.
        </p>

        <p className="-sectionTitle">
          Map Projections:
        </p>

        <ul class="-articleList">
          <li>
            <Link to="/map">
              <small>15 September 2026</small>
              <span>A New Equal-Area Map for Interactive Computer Use</span>
              <span>Seamlessly transitioning to Mercator when zooming</span>
            </Link>
          </li>
        </ul>

        <p className="-sectionTitle">
          The Fast-Date Series:
        </p>

        <ul class="-articleList">
          <li>
            <Link to="/fast-time-of-day">
              <small>7 September 2026</small>
              <span>A faster way to calculate the <em>Time of Day</em></span>
              <span>50% faster than usual, by breaking the dependency chain</span>
            </Link>
          </li>
          <li>
            <Link to="/fast-day-of-week">
              <small>17 August 2026</small>
              <span>A faster way to calculate the <em>Day of the Week</em></span>
              <span>A range of fast modulus techniques that beat compiler output</span>
            </Link>
          </li>
          <li>
            <Link to="/fast-leap-year">
              <small>11 December 2025</small>
              <span>The fastest <em>&ldquo;Is Leap Year&rdquo;</em> functions</span>
              <span>Showcasing techniques from various algorithm designers</span>
            </Link>
          </li>
          <li>
            <Link to="/fast-date-64">
              <small>23 November 2025</small>
              <span>A Very Fast 64&ndash;Bit Date Algorithm: 30-40% faster</span>
              <span>The first date algorithm to use only 4 multiplications, instead of 7+</span>
            </Link>
          </li>
          <li>
            <Link to="/safe-date">
              <small>10 November 2025</small>
              <span>A New Faster Overflow&ndash;Safe Date Algorithm</span>
              <span>12-17% faster than previous algorithms, supporting the full 32&ndash;bit input range.</span>
            </Link>
          </li>
          <li>
            <Link to="/fast-date">
              <small>3 November 2025</small>
              <span>A New Faster Algorithm for Gregorian Date Conversion</span>
              <span>...how "Century-February-Padding" beats traditional year slicing.</span>
            </Link>
          </li>
        </ul>

        <p className="-sectionTitle">
          Date &amp; Time on Mars
        </p>

        <ul class="-articleList">
          <li>
            <Link to="/smoitus">
              <small>26 August 2025</small>
              <span>The Smoital System</span>
              <span>A method of timekeeping on Mars based on UTC</span>
            </Link>
          </li>
        </ul>

        <hr/>

        <p className="-sectionTitle">
          Older stuff:
        </p>

        <ul class="-articleList">
          <li>
            <a href="Perfect_Poker_Coin_Tosses">
              <small>12 Oct 2011</small>
              <span>Perfect Poker Coin Tosses</span>
            </a>
          </li>
          {/*
          <li>
            <a href="/Pocket-Odds-iPhone">
              <small>19 Nov 2010</small>
              <span>Pocket Odds for iPhone released</span>
            </a>
          </li>
          */}
          <li>
            <a href="/PocketOdds_Launched">
              <small>18 Sep 2010</small>
              <span>PocketOdds Launched</span>
            </a>
          </li>
          <li>
            <a href="/omaha">
              <small>5 Sep 2010</small>
              <span>Omaha Ice Cold Decks</span>
            </a>
          </li>
          <li>
            <a href="torus_upgrade">
              <small>8 Feb 2010</small>
              <span>Torus Upgrade</span>
            </a>
          </li>
          <li>
            <a href="holdem">
              <small>5 Oct 2009</small>
              <span>Hold&#8217;em Ice Cold Decks</span>
            </a>
          </li>
        </ul>
        <br/><br/><br/>
        <a href="/vinted">Vinted Australia Promo Code: Get Up to $30 Free Credit"</a><br/>
        <small style={{color:"#666"}}>Leaked hash: c7a398d35e61a3c074a4d5e1cdef8523dd8f3eb47f6030debbda6356820575fd</small>
      </div>
    </Layout>
  );
}

export default Home;